// extracted by mini-css-extract-plugin
export var container = "styles-module--container--J4y9k";
export var heading = "styles-module--heading--3aD-Z";
export var tag = "styles-module--tag--3RYdI";
export var tagName = "styles-module--tagName--2lNlZ";